
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, class_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, UpdateStorageSpaceDto, FormState_$reflection, ToolId_$reflection, UpdateStorageSpaceDto_$reflection, ClientApiResponse$1_$reflection } from "../../../Shared/Shared.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none, Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Input } from "../../../Components/Input.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../../Components/Dialog.js";
import { TextButton } from "../../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetStorageSpace", "StorageSpaceChangeResponse", "StorageSpaceChange", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.ChangeStorageSpaceDialog.Msg", [], Msg, () => [[["Item", string_type]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", class_type("System.Exception")]]]);
}

function postStorageSpaceChangeCmd(toolId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/tools/", toolId.fields[0], ..."/storagespace"), toString(0, Auto_generateBoxedEncoder_437914C6(UpdateStorageSpaceDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(3, [Item_1])));
}

class State extends Record {
    constructor(Dto, ToolId, FormState, SuccessCallback, OnClose) {
        super();
        this.Dto = Dto;
        this.ToolId = ToolId;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
    }
}

function State_$reflection() {
    return record_type("Tools.ChangeStorageSpaceDialog.State", [], State, () => [["Dto", UpdateStorageSpaceDto_$reflection()], ["ToolId", ToolId_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)]]);
}

function init(toolId, storageId, storageSpace, successCallback, onClose) {
    return [new State(new UpdateStorageSpaceDto(storageId, storageSpace), toolId, FormState_get_empty(), successCallback, onClose), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Dto, state.ToolId, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.OnClose), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Dto, state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("tool.dialog_storage_space_change_success"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 2:
            return [new State(state.Dto, state.ToolId, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose), postStorageSpaceChangeCmd(state.ToolId, state.Dto)];
        case 3:
            return [new State(state.Dto, state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose), Cmd_none()];
        default:
            return [new State(new UpdateStorageSpaceDto(state.Dto.StorageId, msg.fields[0]), state.ToolId, state.FormState, state.SuccessCallback, state.OnClose), Cmd_none()];
    }
}

export function DialogBody(props) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = [createElement(Input, {
        ComponentState: props.FormState,
        Label: patternInput[0]("tool.storage_space"),
        OnChange: props.SetStorageSpace,
        TestId: "change-storage-space-input-test-id",
        Value: props.StorageSpace,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ChangeStorageSpaceDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.ToolId, props.StorageId, props.StorageSpace, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = (!props.IsEditableForUser ? true : state_1.FormState.IsLoading) ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("tool.change_storage_space"), {
        Body: singleton(createElement(DialogBody, {
            FormState: componentState,
            SetStorageSpace: (value) => {
                dispatch(new Msg(0, [value]));
            },
            StorageSpace: state_1.Dto.StorageSpace,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-change-storage-space-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(2, []));
            },
            TestId: "save-change-storage-space-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

